import i18n from 'i18next';

/**
 * Translates a value from API response if it's a translation key.
 * 
 * Translation keys are identified by containing a dot (e.g., "status.wip", "table.subordinates").
 * If the key exists in the translation dictionary, it returns the translated value.
 * Otherwise, it returns the original value unchanged.
 * 
 * For keys with dynamic parameters (e.g., "table.teamOf:John Doe"),
 * the format is "key:param" where param is passed as {{name}}.
 */
export const translateApiValue = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }

  // Check for dynamic parameter format: "key:param"
  if (value.includes(':') && value.includes('.')) {
    const [key, param] = value.split(':');
    if (i18n.exists(key)) {
      return i18n.t(key, { name: param }) as string;
    }
  }

  // Check if value looks like a translation key (contains dots)
  if (value.includes('.') && i18n.exists(value)) {
    return i18n.t(value) as string;
  }

  return value;
};

export default translateApiValue;
